<template>
  <VDialog v-model="dialog">
    <VCard height="90vh" style="overflow: auto">
      <VBtn absolute style="right: 0" class="mt-1" icon @click="close">
        <VIcon>mdi-close</VIcon>
      </VBtn>
      <VCardText class="pt-9">
        <ViewerWindow>
          <template #left v-if="item">
            <v-card-title>{{ item.warehouseName }}</v-card-title>
            <order-dialog-header
              :key="`header-${index}`"
              v-for="(product, index) in item.items"
            >
              <template #header
                >{{ product.name }} - {{ product.count
                }}{{ product.unitType }}</template
              >
              <template #details>
                <h4>Qrcode: {{ product.qrcode }}</h4>
                <h4>
                  {{ $t("used") }}:
                  {{ trueSet(product.used) ? $t("yes") : $t("no") }}
                </h4>
              </template>
            </order-dialog-header>
          </template>
          <template #right>
            <pdf-viewer
              class="pt-4"
              ref="pdfViewer"
              :can-upload-file="false"
            ></pdf-viewer>
          </template>
        </ViewerWindow>
        <div class="text-right pt-4">
          <VBtn color="error" class="mr-2" @click="reject">{{
            $t("reject")
          }}</VBtn>
          <VBtn color="primary" @click="approve">{{ $t("approve") }}</VBtn>
        </div>
      </VCardText>
    </VCard>
  </VDialog>
</template>

<script>
import ViewerWindow from "@/components/ui/viewer-window/ViewerWindow.vue";
import PdfViewer from "@/components/pdf/PdfViewer.vue";
import "../order-dialog/_orderDialog.scss";
import OrderDialogHeader from "@/components/order-dialog-header/OrderDialogHeader.vue";
import { trueSet } from "@/utils/pureFunctions.js";

export default {
  name: "OmtkMoveProductInfoDialog",
  components: { OrderDialogHeader, PdfViewer, ViewerWindow },
  data() {
    return {
      dialog: false,
      item: null,
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        const { pdfViewer } = this.$refs;
        this.item = null;
        if (pdfViewer) pdfViewer.clear();
      }
    },
  },
  methods: {
    open(item) {
      this.dialog = true;
      this.getInfo(item.id);
    },
    close() {
      this.dialog = false;
    },
    async getInfo(id) {
      this.showLoading();
      try {
        const { data } = await this.$http.get(
          "product-to-warehouse-application/get-by-id",
          { params: { id } }
        );
        const file = await this.$store.dispatch("getAttachmentFileBase64", {
          link: data.attachmentLink,
        });
        this.item = {
          items: data.items,
          id,
          warehouseName: data.warehouseName,
        };
        this.$nextTick(() => {
          const { pdfViewer } = this.$refs;
          pdfViewer.showFile({ images: file.base64s });
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    approve() {
      this.submit(true);
    },
    reject() {
      this.submit(false);
    },
    async submit(approve) {
      this.showLoading();
      try {
        await this.$http.post("product-to-warehouse-application/save", {
          approve,
          id: this.item.id,
        });
        this.setSuccess({ title: this.$t("successfullySaved") });
        this.close();
        this.$emit("UPDATED");
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
  },
  computed: {
    trueSet: () => trueSet,
  },
};
</script>
